import { ICustomerUser } from './customer.dto';

export class IActivity {
  _id: string;
  organization: string;
  customer: string | ICustomerUser;
  createdBy: { id: string; fullName: string };
  label?: string; // used for type === 'Other'
  type: string;
  /** Origin of the activity. Used to filter emails (Workflow vs System) on the Activity tab. */
  source?: ACTIVITY_SOURCES | string;
  note?: string;
  resourceId?: string;
  resourceType?: string;
  createdAt?: Date;
  updatedAt?: Date;
  meta: any;
}

export enum ACTIVITY_TYPES {
  CALL = 'Call',
  EMAIL = 'Email',
  SMS = 'SMS',
  GORGIAS = 'Gorgias',
  OTHER = 'Other'
}

export enum ACTIVITY_SOURCES {
  /** Sent by the workflow engine */
  WORKFLOW = 'workflow',
  /** Transactional/account emails sent by the platform (password reset, verification, etc.) */
  SYSTEM = 'system'
}

export class CreateActivityDTO {
  type: ACTIVITY_TYPES;
  customer: string;
  label?: string;
  source?: ACTIVITY_SOURCES | string;
  resourceId?: string;
  resourceType?: string;
  note?: string;
  meta?: any;
  createdBy?: { id: string; fullName: string };
}

export class CreateActivityPayload {
  type: ACTIVITY_TYPES;
  customer: string;
  label?: string;
  resourceId?: string;
  resourceType?: string;
  note?: string;
  subject?: string;
  url?: string;
}
